{
  "version": 1,
  "asset_id": "0da1ddf4-f825-4c68-a902-2d3336ca0970",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/0da1ddf4-f825-4c68-a902-2d3336ca0970/destination-roofing-crew-citrus-county-fl-1280.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/0da1ddf4-f825-4c68-a902-2d3336ca0970/destination-roofing-crew-citrus-county-fl-1280.avif",
  "original_filename": "destination-roofing-crew-citrus-county-fl-1280.avif",
  "size": 62361,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:33Z"
}
